import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { ChargePointsQrCodeCell } from './charge-points-qr-code.cell';
import { ChargePointsQrCodeHeader } from './charge-points-qr-code.header';

export const ChargePointsQrCodeColumn: DisplayColumnDef<GatewayChargePointInMaintenanceModel> =
  {
    id: 'qrCode',
    header: ChargePointsQrCodeHeader,
    cell: ChargePointsQrCodeCell,
  };
